var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"body"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }